import axios from 'axios';
import store from '../store';
import router from '../router';

const API = axios.create({
  timeout: 15000,
  baseURL: `${process.env.VUE_APP_API_ENDPOINT}/api/v1`
})
  // const API = axios.create({
  //   baseURL: `https://api.a2dao.com/api/v1`
  // })

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  config.headers = config.headers || {};
  if (token && !config.headers.Authorization && !config.headers.authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

API.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  const requestToken = error?.config?.headers?.Authorization;
  const currentToken = localStorage.getItem('access_token');
  if (error?.response?.status === 401 && !error?.config?.skipAuthLogout &&
      currentToken && requestToken === `Bearer ${currentToken}`) {
    store.dispatch('logOut', { revoke: false });
    router.push('/');
  }

  return Promise.reject(error)
})

export { API };
